import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HiArrowLeft, HiCog6Tooth } from 'react-icons/hi2';
import Header from '../../components/layout/Header';

interface ComingSoonProps {
  title: string;
  description: string;
  icon?: React.ComponentType<{ className?: string }>;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ title, description, icon: Icon }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full pt-16">
      <Header />
      <div className="container max-w-2xl mx-auto py-8 px-4">
        {/* Header with Back Button */}
        <div className="flex items-center mb-8">
          <button
            onClick={() => navigate('/settings')}
            className="flex items-center px-3 py-2 text-base-content/70 hover:text-base-content transition-colors mr-4"
          >
            <HiArrowLeft className="w-5 h-5 mr-1" />
            Back
          </button>
          <h1 className="text-3xl font-semibold text-base-content">
            {title}
          </h1>
        </div>

        {/* Coming Soon Card */}
        <div className="bg-base-100 rounded-lg shadow-sm border border-base-300 p-12 text-center">
          <div className="mb-6">
            {Icon ? (
              <Icon className="w-16 h-16 text-base-content/50 mx-auto" />
            ) : (
              <HiCog6Tooth className="w-16 h-16 text-base-content/50 mx-auto" />
            )}
          </div>
          
          <h2 className="text-2xl font-semibold text-base-content mb-4">
            Coming Soon
          </h2>
          

          <div className="mt-8">
            <button
              onClick={() => navigate('/settings')}
              className="btn btn-primary px-8 py-3"
            >
              Back to Settings
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComingSoon;